import { API_BASE } from "config/api";
import { withAuthHeaders } from "services/authHeader";
import { apiFetch } from "services/apiFetch";

export const getUserInfo = () => {
  try {
    const user = localStorage.getItem("user");
    if (user) {
      const parsedUser = JSON.parse(user);
      console.log("Parsed user from localStorage:", parsedUser);
      return parsedUser;
    }
    console.warn("No user found in localStorage");
    return null;
  } catch (error) {
    console.error("Failed to parse user info:", error);
    return null;
  }
};
// Now you can call it without await

export const resetPassword = async (userObj) => {
  const url = new URL("api/users/resetPassword", API_BASE);

  const res = await apiFetch(url, {
    method: "PATCH",
    headers: withAuthHeaders({
      "Content-Type": "application/json",
      Accept: "application/json",
    }),
    body: JSON.stringify(userObj),
  });
  const result = await res.json();
  return result;
};
